<template>
  <div class="add-new-client">
    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>
        <span>Delete board</span>
        <button class="btn btn--close" @click="deleteDialog = false; showDialog = true"></button>
      </md-dialog-title>
      <div class="margin-auto">
        <span>Are you sure you want to delete the next:</span>
        <div class="textTitle margin-medium--top">
          <span class="textTitleGrey--delete">{{ brand.client.name }}</span>
          <span class="textTitleGrey--delete" style="margin: 0 0.5ch;">/</span>
          <span class="textTitleGrey--delete">{{ brand.name }}</span>
          <span class="textTitleGrey--delete" style="margin: 0 0.5ch;">/</span>
          <span class="textTitlesilver">{{ board.name }}</span>
        </div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="cancel; showDialog = true; deleteDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteBoard">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showDialog">
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(saveBoard)" class="form">
          <md-dialog-title>
            <!-- <span>Edit {{ board.name }}</span> -->
            <span>Edit board</span>
            <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <div class="form__content">
            <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Board name</label>
                <md-input v-model="board_name"/>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <md-dialog-actions>
            <div class="md-layout">
              <div class="md-layout-item row">
                <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                <a class="hrefButton--black margin-medium--left" @click="deleteDialog = true; showDialog = false">Delete
                  Board</a>
              </div>
              <div class="md-layout-item text-right">
                <md-button class="md-primary modal-save-btn" type="submit">Save Board</md-button>
              </div>
            </div>
          </md-dialog-actions>
        </form>
      </validation-observer>
    </md-dialog>
    <div class="row">
      <a class="hrefButton margin-medium--right" @click="showDialog = true">
        Edit Board
      </a>

    </div>
  </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "Board name is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  props: ['board', 'brand'],
  mixins: [apiHandlerMI],
  data() {
    return {
      board_name: this.board.name ? this.board.name : null,
      deleteDialog: false,
      showDialog: false,
      active: false,
      error: [],
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    deleteBoard() {
      const _this = this;
      this.delete(`board/${this.board.id}`, {}, () => {
        _this.showDialog = false;
        _this.deleteDialog = false;
        _this.$parent.refreshBrand();
        _this.$parent.selectFirstBoard();
      }, () => {
        console.log('Sikertelen Torles');
      });
    },
    saveBoard() {
      var _this = this;

      this.put('board/' + this.board.id, {name: this.board_name}, {}, function () {

        if (_this.$parent.refreshBrand)
          _this.$parent.refreshBrand();
        _this.showDialog = false
      }, function (resp) {
        //console.log(resp);
        _this.error = resp.data.error;
        this.$forceUpdate();
      })
    },

    cancel() {
      this.showDialog = false
      this.board_name = this.board.name;
    }
  },
  watch: {
    board(newValue) {
      this.board_name = newValue.name
    }
  }
}
</script>